export default {
  platformRow1: 'JWI云平台是基于云原生(Cloud Native)架构开发的管理企业级应用工业软件或企业数字化PAAS平台，主要特性如下',
  platformRow2: '服务化：服务治理和提供标准化服务组件',
  platformRow3: '开发环境：提供快速开发交付应用环境支撑',
  platformRow4: 'DevOps：持续集成/持续部署过程管理环境',
  platformRow5: '自动化运维：应用、容器和硬件环境自动化运维工具支持。'
}
